import { useCallback } from 'react';

import { useAppConfig } from '#/config/AppConfigContext';
import { isomorphicIsExternalUrl } from '#/utils/url/isomorphicIsExternalUrl';

export function useIsExternalUrl() {
  const { appConfig } = useAppConfig();
  const { appUrl } = appConfig.idealist;

  const isExternalUrl = useCallback(
    (url: string) => {
      return isomorphicIsExternalUrl({ url, appUrl });
    },
    [appUrl],
  );

  return { isExternalUrl };
}
